import React, { useState } from "react";
import { useMutation } from "react-query";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import BackBtn from "../lib/BackBtn";
import { TicketInSpecialValidationSchema } from "./TicketInSpecialValidationSchema";
import TicketInSpecialForm from "./TicketInSpecialForm";
import { addTicketSpecial } from "../../../api/ticket/tikectSpecial";
import { ButtonWithoutIcon } from "../lib";


function AddTicketSpecial() {
  const [searchParams] = useSearchParams();
  const pageFromQuery = searchParams.get("page");
  const page = pageFromQuery ? parseInt(pageFromQuery) : 1;
  const navigate = useNavigate();
  const addMutation = useMutation((ticket: FormData) => addTicketSpecial(ticket));
  const initialValues = {
    file: null,
    matchId: 0,
    profilePlatformId: 0,
    operatorId: "",
    attendees: [{
      name: "",
      mobile: "",
      national_code: "",
      male: true,
      used_count: "",
    }]
  };


  const goBack = () =>
    navigate({
      pathname: `/ticket-in-special/add-ticket-special?page=${page}`,
    });

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const formik = useFormik({
    initialValues,
    validationSchema: TicketInSpecialValidationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      
      const formData = new FormData();
      
      if (values.file) {
        formData.append('file', values.file);
      }
      
      formData.append('matchId', values.matchId.toString());
      formData.append('profilePlatformId', values.profilePlatformId.toString());
      formData.append('organizationId', values.operatorId.toString());
      
      const attendeesData = Array.isArray(values.attendees) ? values.attendees : [values.attendees];
      
      formData.append('attendees', JSON.stringify(attendeesData));

      console.log('Form Data:', {
        file: values.file,
        matchId: values.matchId,
        profilePlatformId: values.profilePlatformId,
        organizationId: values.operatorId,
        attendees: attendeesData
      });

      addMutation.mutate(formData, {
        onSuccess: () => {
          toast.success("بلیت ویژه با موفقیت ایجاد شد", {
            position: "top-center",
          });
          setIsLoading(false);
          formik.resetForm();
          addMutation.reset();
          goBack();
        },
        onError: (e: any) => {
          setIsLoading(false);

          const hasErrors = Object.keys(e?.response?.data).length > 0;

          if (hasErrors) {
            const formattedErrors = Object.entries(e?.response?.data).flatMap(
              ([key, value]) => {
                if (Array.isArray(value)) {
                  return value.flatMap((errorObj) => {
                    return Object.entries(errorObj).map(([field, message]) => {
                      return (
                        <div
                          key={`${field}-${message}`}
                        >{`${field}: ${message}`}</div>
                      );
                    });
                  });
                }
                if (typeof value === "object" && value != null) {
                  return Object.entries(value).map(([field, message]) => {
                    return (
                      <div
                        key={`${field}-${message}`}
                      >{`${field}: ${message}`}</div>
                    );
                  });
                }
                return [<div key={key}>{`${key}: ${value}`}</div>];
              }
            );

            toast.error(
              <div>
                <div>لطفاً موارد زیر را اصلاح کنید:</div>
                {formattedErrors}
              </div>,
              {
                position: "top-center",
                autoClose: false,
                closeOnClick: true,
              }
            );
            return;
          }
        },
      });
    },
  });

  return (
    <div className={"card"}>
      <div
        className={
          "card-title mt-5 mb-1 px-10 d-flex align-items-center justify-content-between "
        }
      >
        <h2>بلیت ویژه</h2>
        <div className="d-flex            ">
        <ButtonWithoutIcon
                    btnText={"دریافت اکسل "}
                    type={"click"}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(
                        "/ticket-in-special/add-excel-special"
                      );
                    }}
                  />
                          <BackBtn onClick={() => goBack()} />

        </div>

      </div>
      <TicketInSpecialForm
        loading={isLoading}
        formik={formik}
        labels={{ sendBtnLabel: "ذخیره" }}
      />
    </div>
  );
}

export default AddTicketSpecial;
